export enum ApplicationEmploymentInfoType {
  CURRENT = 'Current',
  PREVIOUS = 'Previous',
}

export interface ApplicationEmploymentInfoDto {
  id: string;
  type: ApplicationEmploymentInfoType;
  jobTitle: string | null;
  companyName: string | null;
  netIncome: number | null;
  startDate: string | null;
  endDate: string | null;
  isCurrent: boolean;
  managerName: string | null;
  managerPhone: string | null;
  managerEmail: string | null;
  createdAt: string;
  updatedAt: string;
}
